import { motion } from "framer-motion";
import * as React from "react";

const AnimatedShorthandPattern = ({ className = "" }: { className?: string }) => {
  return (
    <svg width="770" height="770" viewBox="0 0 770 770" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Top-left shape - starts at top-left, rotates clockwise */}
      <motion.rect
        width="367"
        height="367"
        rx="183.5"
        fill="#03302B"
        animate={{
          x: [0, 403, 403, 403, 403, 0, 0, 0],
          y: [0, 0, 0, 403, 403, 403, 403, 0],
        }}
        transition={{
          duration: 32,
          times: [0, 0.0625, 0.25, 0.3125, 0.5, 0.5625, 0.75, 0.8125],
          repeat: Infinity,
          ease: [0.645, 0.045, 0.355, 1],
        }}
      />

      {/* Bottom-left shape - starts at bottom-left, rotates clockwise */}
      <motion.rect
        width="367"
        height="367"
        rx="50"
        fill="hsla(169,80%, 26%, 1)"
        animate={{
          x: [0, 0, 0, 403, 403, 403, 403, 0],
          y: [403, 0, 0, 0, 0, 403, 403, 403],
        }}
        transition={{
          duration: 32,
          times: [0, 0.0625, 0.25, 0.3125, 0.5, 0.5625, 0.75, 0.8125],
          repeat: Infinity,
          ease: [0.645, 0.045, 0.355, 1],
        }}
      />

      {/* Top-right shape - starts at top-right, rotates clockwise */}
      <motion.rect
        width="367"
        height="367"
        rx="50"
        fill="#542C57"
        animate={{
          x: [403, 403, 403, 0, 0, 0, 0, 403],
          y: [0, 403, 403, 403, 403, 0, 0, 0],
        }}
        transition={{
          duration: 32,
          times: [0, 0.0625, 0.25, 0.3125, 0.5, 0.5625, 0.75, 0.8125],
          repeat: Infinity,
          ease: [0.645, 0.045, 0.355, 1],
        }}
      />

      {/* Bottom-right shape - starts at bottom-right, rotates clockwise */}
      <motion.rect
        width="367"
        height="367"
        rx="183.5"
        fill="#C69748"
        animate={{
          x: [403, 0, 0, 0, 0, 403, 403, 403],
          y: [403, 403, 403, 0, 0, 0, 0, 403],
        }}
        transition={{
          duration: 32,
          times: [0, 0.0625, 0.25, 0.3125, 0.5, 0.5625, 0.75, 0.8125],
          repeat: Infinity,
          ease: [0.645, 0.045, 0.355, 1],
        }}
      />
    </svg>
  );
};

export default AnimatedShorthandPattern;
